import { apiClient } from "../../Config/ApiClient";

export const retrieveAdvertisement = (token, data) => apiClient.get(`/advertisements`, { headers: {'Authorization': token}, params: data });

export const createAdvertisement = (token, data) => apiClient.post(`/advertisements/add`, data, { headers: {'Authorization': token}});

export const updateAdvertisement = (token, data, id) => apiClient.post(`/advertisements/update/${id}`, data, { headers: {'Authorization': token}});

export const deleteAdvertisement = (token, id) => apiClient.post(`/advertisements/delete/${id}`, {}, { headers: {'Authorization': token }});

export const uploadAdvertisement = (token, data) => apiClient.post(`/upload`, data, { headers: {'Authorization': token, 'Content-Type': 'multipart/form-data'}});

export const retrieveAdvertisementPhoto = (token, file) => apiClient.get(`/files/${file}`, { headers: {'Authorization': token} });

